module.exports = __webpack_public_path__ + "img/pattern.aacac1c5.png";